import { AnalyticsEvent } from '../models';

export class NutritionCalculatorPageLoadEvent implements AnalyticsEvent {
  name = 'NutritionCalculatorPageLoadEvent';

  constructor(public readonly eventType?: string, public readonly mealType?: string) {}
}